import axios from 'axios';
import moment from 'moment-timezone';

export default (type, extension = {}) => {
  function _update(teamId, eventId, showId, changes) {
    return axios
      .post(`/api/${type}.update`, {
        params: { teamId, eventId, showId },
        payload: changes,
      })
      .then((res) => res.data);
  }

  return Object.assign(
    {},
    {
      /**
       * Create a new list
       */
      create(teamId, eventId, show, template, parentFolderId) {
        show.itemSetSize = 5;

        return axios
          .post(`/api/${type}.create`, {
            params: { teamId, eventId },
            payload: { show, template, parentFolderId },
          })
          .then((res) => res.data);
      },

      /**
       * Create a new list via csv import
       */
      createFromCsv(teamId, eventId, csv) {
        return axios
          .post(`/api/${type}.createFromCsv`, {
            params: { teamId, eventId },
            payload: { csv },
          })
          .then((res) => res.data);
      },

      /**
       * Duplicate list to a target event
       */
      duplicateToTarget(
        teamId,
        eventId,
        showId,
        targetEventId,
        titleSuffix = ' - Copy',
      ) {
        return axios
          .post(`/api/${type}.duplicateToTarget`, {
            params: { teamId, eventId, showId, targetEventId },
          })
          .then((res) => {
            return this.update(teamId, eventId, res.data._id, {
              title: res.data.title + titleSuffix,
            });
          });
      },

      /**
       * Duplicate a list
       */
      duplicate(
        teamId,
        eventId,
        showId,
        skipFSObject,
        titleSuffix = ' - Copy',
        parentId,
      ) {
        let query = {};
        if (skipFSObject) query.skipFSObject = '1';
        if (parentId) query.parentId = parentId;

        return axios
          .post(`/api/${type}.duplicate`, {
            params: { teamId, eventId, showId },
            query,
          })
          .then((res) => {
            return this.update(teamId, eventId, res.data._id, {
              title: res.data.title + titleSuffix,
            });
          });
      },

      /**
       * Update a list
       */
      update: _update,

      /**
       * Update a list field
       */
      updateField(teamId, eventId, showId, field, value) {
        let changes = {};
        changes[field] = value;

        return _update(teamId, eventId, showId, changes);
      },

      /**
       * Create a saved version
       */
      createSavedVersion(teamId, eventId, showId) {
        return this.duplicate(
          teamId,
          eventId,
          showId,
          true,
          ' - ' + moment().format('MM/DD/YYYY @ HH:mm:ss'),
        ).then((show) =>
          this.update(teamId, eventId, show._id, { saved: true }),
        );
      },

      /**
       * Create a template
       */
      createTemplate(teamId, eventId, showId, title) {
        return this.duplicate(teamId, eventId, showId, true).then((show) =>
          this.update(teamId, eventId, show._id, { title, template: true }),
        );
      },

      /**
       * Create a show from a saved version
       */
      createFromSavedVersion(teamId, eventId, showId) {
        return this.duplicate(
          teamId,
          eventId,
          showId,
          false,
          ' - From Saved',
        ).then((show) =>
          this.update(teamId, eventId, show._id, { saved: false }),
        );
      },

      /**
       * Restore a deleted show
       */
      restore(teamId, eventId, showId) {
        return axios
          .post(`/api/${type}.restore`, {
            params: { teamId, eventId, showId },
          })
          .then((res) => res.data);
      },

      archiveTemplate(teamId, eventId, showId) {
        return axios
          .post(`/api/show.hardDelete`, {
            params: { teamId, eventId, showId },
          })
          .then((res) => res.data);
      },

      restoreTemplate(teamId, eventId, showId) {
        return axios
          .post(`/api/show.restoreTemplate`, {
            params: { teamId, eventId, showId },
          })
          .then((res) => res.data);
      },
    },
    extension,
  );
};
